import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  tabs: {
    borderBottom: 1,
    borderColor: 'divider',
    width: '100%',
    paddingLeft: '16px',
  },
});
